import React from 'react';
import { Edit, SimpleForm, TextInput } from 'react-admin';
import { Wrapper } from '../../components';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';

const ParentFuelEdit = (props) => {
    return (
        <Permission permission={PERMISSIONS.ADMIN}>
            <Wrapper>
                <Edit title='Editar combustível' {...props}>
                    <SimpleForm sx={{ maxWidth: 600 }}>
                        <TextInput disabled label="ID" source="id" sx={{ minWidth: 300 }} />
                        <TextInput source="acronym" label="Sigla" maxlength="3" sx={{ minWidth: 300 }} />
                        <TextInput source="name" label="Nome" sx={{ minWidth: 300 }} />
                    </SimpleForm>
                </Edit>
            </Wrapper>
        </Permission>
    )
};

export default ParentFuelEdit;
